import { VENDOR_JOB_DETAILS_REQUEST, VENDOR_JOB_DETAILS_SUCCESS, VENDOR_JOB_DETAILS_FAIL } from "../constants/AuthConstant"

const initialState = {
  loading: true,
  action: "Job Action",
  result: null,
  msg: "",
  error: "",
};

const VendorJobDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_JOB_DETAILS_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case VENDOR_JOB_DETAILS_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case VENDOR_JOB_DETAILS_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default VendorJobDetailsReducer;
